import type { TAdditionalDataFormFields } from 'src/client/entities/creditForm';

export const AdditionalInfoTexts: Record<keyof TAdditionalDataFormFields, string> = {
  education: 'Образование',
  maritalStatus: 'Семейное положение',
  numberOfDependents: 'Дети до 18 лет',
  additionalPhoneOwner: 'Владелец телефона',
  additionalPhoneOwnerFullName: 'ФИО владельца номера',
  carAvailability: 'Тип автомобиля',
  carAvailabilityToggleEnabled: 'Есть автомобиль',
  propertyTypeAvailability: 'Тип недвижимости',
  propertyTypeAvailabilityToggleEnabled: 'Есть недвижимость',
  additionalPhone: 'Номер телефона',
  snils: 'СНИЛС',
};

export const AdditionalInfoModalTexts = {
  title: 'Дополнительные данные',
  description: 'Проверьте, что всё верно, и внесите изменения',
};
